// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { PutVocAutoMateTasksBody, BaseResponseMapintobject } from '../types';

/**
 * update
 *
 * @export
 * @tags voc自动化配置
 * @link [PUT] /vocAutoMateTasks
 */
export function putVocAutoMateTasks(
    data: PutVocAutoMateTasksBody
): Promise<BaseResponseMapintobject>;
export function putVocAutoMateTasks(
    data: PutVocAutoMateTasksBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseMapintobject>;
export function putVocAutoMateTasks(
    data: PutVocAutoMateTasksBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseMapintobject> {
    return request<PutVocAutoMateTasksBody, never, never>('/vocAutoMateTasks', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putVocAutoMateTasks',
    });
}

export const meta = [{ tags: ['voc自动化配置'], path: '/vocAutoMateTasks', method: 'put' }];
